<div class="mpcboardview">
    <app-branding-header-bar></app-branding-header-bar>
    <app-informationview [viewName]="'mpc-board'"></app-informationview>

    <!-- Test-buttons for dependency -->
    <div>
        <!-- Test-buttons for edit mode -->
        <button mat-mini-fab class="test editmode"
            [ngClass]="{'active' : (DependencyEditmodeService.editModeActive)}"
            (click)="toggleEditMode()">
            <mat-icon>create</mat-icon>
        </button>
        <button mat-mini-fab class="test toggle-draw" (click)="toggleShowDependencies()"
        [disabled]="DependencyEditmodeService.editModeActive">
            <mat-icon *ngIf="(dependencyDrawingService.dependenciesVisible === true)">visibility</mat-icon>
            <mat-icon *ngIf="(dependencyDrawingService.dependenciesVisible === false)">visibility_off</mat-icon>
        </button>
    </div>

    <div id="actionview" class="actionview">
        <div id="mpc-main-container" cdkDropListGroup [ngClass]="{'transparent-background' : this.backgroundVideoIsActive}">
            <!-- Teams -->
            <ng-template #mpcBoardTeamInsertionPoint></ng-template>

            <!-- Add Team -->
            <div class="add-team">
                <mat-form-field>
                    <mat-select placeholder="Team" [(ngModel)]="selectedTeamKey">
                        <mat-option *ngFor="let teamKey of availableTeamsKeys" [value]="teamKey">{{teamKey}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <button mat-raised-button (click)="addTeamToProgram()">Add to Board</button>
            </div>

            <!-- Create Team -->
            <!--
            <div class="actionview__createteam">
                <a class="mpc-action">+ Create Team</a>
            </div>
            -->
        </div>
    </div>

    <!-- Footer -->
    <app-footerbar></app-footerbar>

    <div id="popupContainer">
        <ng-template #popupInsertionPoint></ng-template>
    </div>
</div>
